export function getOwnPropertyDescriptors(obj) {
    const descriptors = {};
    Object.getOwnPropertyNames(obj).forEach((prop) => {
        descriptors[prop] = Object.getOwnPropertyDescriptor(obj, prop);
    });
    return descriptors;
}
//# sourceMappingURL=object_helpers.js.map